import { createAction, props } from '@ngrx/store';

export const ADD_MESSAGE = createAction(
  '[MESSAGES] - add message',
  props<{ message: string }>()
);

export const RESET_MESSAGE = createAction(
  '[MESSAGES] - reset message'
);

